import { getPlaceDetails, selectPlaceData } from 'containers/MapDetails/placeSlice'
import WarehouseAttrPopup from 'containers/Maps/Popups/WarehouseAttrPopup'
import AutomationPopup from 'containers/Maps/Popups/AutomationPopup'
import GalleryPopup from 'components/popups/GalleryPopup'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useEffect, useState } from 'react'
import MmRating from 'components/MmRating'
import './style.scss'

const ObjectDetails = ({ data, warehouseTypeId }) => {
  const { id, isAnnouncement, mm_score, mm_score_info, automation, place_attrs, important_attrs, city, street, estateNumber, localNumber, sizes, photos } = data || {}
  const [mainImg, setMainImg] = useState({ index: 0, url: null })
  const [activeSize, setActiveSize] = useState(null)
  const { popup, openPopup } = usePopupState()
  const { placeId: placeIdParams } = useParams()
  const { tabs } = useSelector(selectPlaceData)

  const extraPhotosCount = photos?.length > 4 ? photos.length - 4 : 0

  const { push } = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation('mapDetails')

  useEffect(() => {
    dispatch(getPlaceDetails(placeIdParams))
  }, [placeIdParams, dispatch])

  useEffect(() => {
    if (photos?.length > 0) {
      setMainImg({ index: 0, url: photos[0].public_path });
    }
  }, [photos]);

  useEffect(() => {
    if (sizes && sizes.length > 0) {
      const newSize = warehouseTypeId
        ? (sizes?.find(s => s.warehouseTypeId === warehouseTypeId) || sizes[0])
        : sizes[0]
      setActiveSize(newSize)
    }
  }, [sizes, warehouseTypeId])

  const handleGo = () => {
    if (isAnnouncement) {
      openPopup({ type: 'announcement', placeId: id })
    } else {
      push(`/mapdetails/${id}${activeSize ? `?warehouseTypeId=${activeSize.warehouseTypeId}` : ''}`)
    }
  }

  const handleMainImgChange = (index) => {
    setMainImg({ index, url: photos[index].public_path });
  }

  return (
    <>
      {popup === 'warehouse_attr' && <WarehouseAttrPopup body={place_attrs} />}
      {popup === 'automation' && <AutomationPopup body={automation} />}
      {popup?.type === 'gallery' && <GalleryPopup initialSlide={popup.index} data={photos} />}

      <div className='objectDetails'>
        <div className='objectDetails__head'>
          <div className='objectDetails__head__imgs'>
            <div className='mainImg'>
              {mainImg.url && <img
                src={mainImg.url}
                alt=''
                onClick={() => {
                  openPopup({ type: 'gallery', index: mainImg.index })
                }} />}
            </div>
            <div className='thumbnails'>
              {photos?.slice(0, 3)?.map((photo, index) => (
                <img
                  key={index}
                  src={photo.thumbnail || photo.public_path}
                  alt={photo.document_title || ''}
                  onClick={() => handleMainImgChange(index)}
                  style={{ cursor: 'pointer' }}
                />
              ))}

              {/* Warunek dla ostatniego elementu */}
              {photos?.length > 4 ? (
                <div className='lastItem'>
                  <img
                    src={photos[3].thumbnail || photos[3].public_path}
                    alt={photos[3].document_title || ''}
                    onClick={() => handleMainImgChange(3)}
                    style={{ cursor: 'pointer' }}
                  />
                  <span>+{extraPhotosCount}</span>
                </div>
              ) : (
                photos?.[3] && (
                  <img
                    src={photos[3].thumbnail || photos[3].public_path}
                    alt={photos[3].document_title || ''}
                    onClick={() => handleMainImgChange(3)}
                    style={{ cursor: 'pointer' }}
                  />
                )
              )}
            </div>
          </div>
          <div className='objectDetails__head__content'>
            <div className='placeElement__name'>
              <h2>{city}, {street} {localNumber} {estateNumber}</h2>
              {typeof mm_score === 'number' && <MmRating
                number={mm_score}
                action={() => openPopup({ type: 'mm_score', scoreInfo: mm_score_info })}
              />}
            </div>

            <div className='placeElement__automation' onClick={() => openPopup('automation')}>
              <div>
                {automation?.key === 'full-automatic'
                  ? <i className='icon icon--shield'></i>
                  : null}
                <span className={`${automation?.key === 'full-automatic' ? 'green' : ''}`}>{automation?.title}</span>
              </div>
              <div>{automation?.description}</div>
            </div>

            <div className='placeElement__sizes'>
              <span className='subtitle'>{t('availableSizes')}</span>
              {sizes?.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    className={`sizeItem ${item.warehouseTypeId === (activeSize && activeSize.warehouseTypeId) ? 'active' : ''}`}
                    onClick={() => setActiveSize(item)}>
                    {item.sizeShortName || item.size}
                  </div>
                )
              })}
            </div>

            <div className='placeElement__price'>
              <span className='subtitle'>{t('costOfSelectedSize')}</span>
              <span className='--secFont'>{t('from')} {activeSize?.monthlyGrossPrice} zł</span>
              <span className='--secFont small'>/ {t('monthly')}</span>
            </div>

            <ArrowBtn
              action={handleGo}
              text={t(isAnnouncement ? 'seeTheOffer' : 'seeTheWarehouses')}
            />
          </div>
        </div>
        <div className='objectDetails__body'>
          <div
            className='objectDetails__attrs'
            onClick={() => openPopup('warehouse_attr')}>
            <div className='objectDetails__attrs__title'>
              <h3>{t('attributesOfTheYard')}</h3>
            </div>
            <div className='objectDetails__attrs__content'>
              <div className='placeElement__attr' >
                {place_attrs?.map((item) => {
                  return (
                    <div key={item.id} className='placeElement__attr__item'>
                      <i className={`icon icon--check`}></i>
                      <span>{item.name}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className='objectDetails__important'>
            <div className='objectDetails__important__title'>
              <h3>{t('importantInformation')}</h3>
            </div>
            <div className='objectDetails__important__content'>
              {important_attrs?.map((item, idx) => {
                return (
                  <div className='item' key={idx}>
                    <span>{item.title}</span>
                    <span>{item.name}</span>
                    <i className='icon icon--info'></i>
                  </div>
                )
              })}
            </div>
          </div>

          <div className='objectDetails__tabs'>
            {tabs?.map((tab, index) => (
              <div key={index} className='tab'>
                <div className='tab__title'>
                  <h3>{tab.name}</h3>
                </div>
                <div className={`tab__content ${tab?.type === 'list' ? '--list' : ''}`}>
                  {tab?.type === 'list' ? (
                    tab.content.map((item, itemIndex) => (
                      <div key={itemIndex} className='item'>
                        <h4>{item.name}</h4>
                        <p>{item.description}</p>
                      </div>
                    ))
                  ) : (
                    <div
                      className='htmlFromApi'
                      dangerouslySetInnerHTML={{ __html: tab.content }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>)
}

export default ObjectDetails